module.exports = __webpack_public_path__ + "img/portrait-cup.bd353d75.svg";